export default {
  hydrated: false,
  activities: []
}



// WEBPACK FOOTER //
// ./~/vue-components/live-coach/store/state.js